import { any, node } from 'prop-types'
import {Stack} from "@bedrock-layout/stack";
import React from "react";

function FieldGroup({children, ...rest}){
  return(
      <Stack gutter="xl" {...rest}>
        {children}
      </Stack>
  )
}


FieldGroup.propTypes = {
  children: node.isRequired,
  rest: any
}

export default FieldGroup
